import { render, staticRenderFns } from "./App.vue?vue&type=template&id=a680d78a&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=a680d78a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a680d78a",
  null
  
)

export default component.exports